import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { Button } from "@workspace/ui/components/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@workspace/ui/components/card";
import { z } from "zod";
import { ResetPasswordForm } from "@/features/auth/reset-password-form";

const searchSchema = z.object({
  token: z.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/reset-password")({
  component: ResetPassword,
  validateSearch: searchSchema,
});

function ResetPassword() {
  const { token, error } = useSearch({ from: "/(auth)/reset-password" });
  const invalid = Boolean(error) || !token;

  return (
    <Card className="gap-4">
      <CardHeader>
        <CardTitle className="text-lg tracking-tight">Set a new password</CardTitle>
        <CardDescription>Use at least 8 characters. All previous sessions will be signed out.</CardDescription>
      </CardHeader>
      <CardContent>
        {invalid ? (
          <div className="grid gap-4">
            <p className="text-muted-foreground text-sm">This reset link is invalid or has expired.</p>
            <Button asChild>
              <Link to="/forgot-password">Request a new link</Link>
            </Button>
          </div>
        ) : (
          <ResetPasswordForm token={token} />
        )}
      </CardContent>
    </Card>
  );
}
